<template>
    <div class="textSet-column c-textSetColumn mr-2 d-flex align-center px-0 pt-0 pb-2" style="display: flex; flex-direction: row; width:100%;">
        <span class="mr-2 pr-4 text--primary"><translation-container :context="this" value="If"></translation-container></span>
        <div :style='{ width: "100%", backgroundColor: this.valueErrorMessages.length ? "transparent" : "var(--v-white-base)"}'>
            <DropdownMultiSelectBase
                :source="allListItems"
                nameField="name"
                valueField="value"
                :settings="settings"
                :isopen="isopen"
                :ccmodel="selected_items"
                :showCheckAll="true"
                :showUncheckAll="true"
                :hideLabelSlot="true"
                :emptyLabel="Translate('Select')"
                :placeholder="Translate('Select')"
                hideDetails
                :rules="valueRules"
                :errorMessages="valueErrorMessages"
                :error="valueErrorMessages.length > 0"                
                @input="relayChange"
                @empty="toggleAll">
            </DropdownMultiSelectBase>
        </div>
        <span class="mx-2 text--primary"><translation-container :context="this" value="then"></translation-container></span>
        <ThresholdformatOptions :EventBus="EventBus" :defaultColor="value.color" @thresholdFormatChanged="thresholdFormatChanged"/>
    </div>
</template>

<script>
    import Vue from "vue";
    import utils from '@/Shared/utils.jsx';
    import helps from '@/Application/careHelpfulFunctions.jsx';
    import common from './common.js';
    import _ from 'lodash';
    import methods from '@/Shared/methods';

    import { appSettings } from '@/Shared/appSettings';

    import DropdownMultiSelectBase from "../DropdownMultiSelectBase.jsx";
    import ThresholdformatOptions from './threshold_formatOptions.vue';

    export default {
        components: {
            DropdownMultiSelectBase,
            ThresholdformatOptions
        },
        data: function () {
            return {
                usefulltext: false,
                usecurrentuser: false,
                values: {},
                selected_items: [],
                search: '',
                listitems: [],
                showunique: true,
                query_in_progress: false,

                expn: null,
                isUserID: false,

                isAllSelected: false,
                useExclusive: false,
                //lookups: {},
                queryError: '',
                valueErrorMessages:[]
            }
        },
        props: {
            item: Object,
            settings: null,
            value: null,
            initial: null,
            isopen: null,
            advancedSettings: null,
            EventBus: null,
        },
        created() {
            console.log(`created textSetColumn(colId:${this.item.ColId}) DBLookupList:${this.item.DBLookupList}, showunique:${this.showunique}`);

            this.isUserID = this.item.SourceType == 'userIDColumn';
            this.showunique = (this.item.SourceType != 'userIDColumn' && this.item.SourceType != 'customerIDColumn') &&
                (this.item.MappingTableType == 'None' || (!this.item.MappingTableType && !this.item.DBLookupList));

            this.initializeFromValue(this.value);

            if (this.initial && this.initial.usage == 2 && this.initial.mode != 'exclusive') {
                // We are in ReadOnly mode and the filter has the usage flag set to "limited".
                // The set of values in initial.values represents the only values the user can pick from.
                this.listitems = this.initial.values;
            }
            else
                this.loadColumnValues();

        },
        computed: {
            isDEBUG: function () {
                return appSettings.DEBUG;
            },
            allListItems: function() {
                let renderedListItems = [];
                if (this.listitems) 
                {   
                    this.listitems.forEach(entry => {
                        renderedListItems.push({
                            value: entry,   
                            name: this.transformValue(entry)
                        });
                    });
                }
                return renderedListItems;
            },  
            allDescription: function () {
                if (this.isAllSelected)
                    return this.Translate('All unselected items will become an exclusion list. This');
                else
                    return this.Translate('(Selection is an inclusion list)');
            },
            allowStandardTextFilter: function () {
                return (this.item.MappingTableType != 'LookupAPI' || !this.item.CompoundFilter) && (!this.haslookup || this.isDEBUG);
            },

            UniqueValuesVisible: function () {
                return (this.item.MappingTableType == 'LookupAPI' || (!this.item.MappingTableType && this.item.DBLookupList) ||
                    this.item.SourceType == 'userIDColumn' || this.item.SourceType == 'customerIDColumn') &&
                    (!this.initial || this.initial.usage < 2) && !this.item.CompoundFilter;
            },
            standardTextFilterTooltip: function () {
                return this.Translate(`Switch to a mode where you define the filter using conditional values (for example, a queue name filter CONTAINS 'Sales' OR CONTAINS 'Support')`);
            },
            haslookup: function () {
                return (this.item.SourceType == 'userIDColumn' || this.item.SourceType == 'customerIDColumn' ||
                    (this.item.lookups && Object.keys(this.item.lookups).some(k => this.item.lookups[k] != k)));
            },
            valueRules() {
                return [
                    v => v.length || this.Translate('Please select a value')
                ];
            },
        },
        watch: {
            showunique: function (newv) {
                this.loadColumnValues();
            },
            selected_items: function (newv) {
                this.updateFilter(newv);
            },
            selected_filtered_items: function (newv) {
                this.updateSelectedFilteredItems(newv);
            },
            usecurrentuser: function (newv) {
                this.updateFilter(this.selected_items);
            },
            usefulltext: function (newv) {
                if (!newv)
                    this.updateFilter(this.selected_items);
            },
            useExclusive: function (newv) {
                this.updateFilter(this.selected_items);
            },
            advancedSettings: function (newv) {
                if (!newv) {
                    this.usefulltext = false;
                    this.showunique = false;
                }
            },
            isopen: function(newv) {
                if (newv)
                    this.loadColumnValues();
            },
        },
        methods: {
            ...methods,
            initializeFromValue(value) {
                if (value.value)
                {
                    this.selected_filtered_items  = value.value;
                    this.selected_items = Array.isArray(value.value) ? value.value : [value.value];
                }
                this.useExclusive = value.mode == 'exclusive';
                this.isAllSelected = this.useExclusive;
            },
            updateSelectedFilteredItems(newv)
            {
                if (!this.useExclusive)
                {
                    if (this.hidden_selected_items)
                    {
                        newv =  [...newv, ...this.hidden_selected_items];
                    }
                } 
                else 
                {
                    var itemsToExclude = [...newv, ...this.hidden_selected_items];
                    newv = this.listitems.filter(item => !itemsToExclude.includes(item));
                }
                this.updateFilter(newv);              
            },
            updateFilter(newv) {
                var newDisplayValues = [];
                 newv.forEach(entry => {
                     newDisplayValues.push(this.transformValue(entry));
                 });
                // Handle the ReadOnly, usage:2 scenario first
                if (this.initial && this.initial.usage == 2 && newv.length)
                    this.$emit('thresholdValuesChanged', {
                        filterType: "set",
                        value: newv,
                        displayValues: newDisplayValues,
                        mode: 'inclusive',
                        type: "set"            // Always inclusive mode when viewing a report, the exclusions will be filtered out of the list
                    });
                else if (this.initial && this.initial.usage == 2)
                    this.$emit('thresholdValuesChanged', {
                        filterType: "set",
                        value: this.initial.values, // If no items are selected, we fall back to the limited set
                        mode: this.initial.mode,      // No values set then requires we honor the mode
                        displayValues: newDisplayValues,
                        type: "set"                    
                    });
                else if (this.usecurrentuser)
                    this.$emit('thresholdValuesChanged', {
                        filterType: "text",
                        type: "equals",
                        filter: "{{CurrentUserID}}",
                        usage: 0,                        
                        type: "text"
                    });
                else if ((!newv || (newv.length == this.listitems.length && !this.item.CompoundFilter) || newv.length < 1) && (!this.initial || this.initial.usage < 2))
                    // When editing or unlimited filtering, when all items are selected, we disable this filter
                    this.$emit('thresholdValuesChanged', {});
                else
                    // Emit the actual one-to-many values associated with the selected names
                    this.$emit('thresholdValuesChanged', {
                        filterType: "set",
                        value: newv,
                        mode: this.useExclusive ? 'exclusive' : 'inclusive',
                        displayValues: newDisplayValues,
                        type: "set"
                        //compound: this.item.CompoundFilter,
                    });
                    this.triggerValidation();
            },
            async loadColumnValues() {
                // This is for ReadOnly and limited mode, no need to refresh
               // if (this.initial && this.initial.usage == 2 && this.initial.mode != 'exclusive') return;
                this.query_in_progress = true;
                this.queryError = '';

                console.log(`loadColumnValues(colId:${this.item.ColId}) DBLookupList:${this.item.DBLookupList}, showunique:${this.showunique}`);

                if (this.showunique) {
                    const dataurl = `${common.buildRequest('Apps/ReportStudio/AdvancedReporting/GetUniqueColValues', this.settings.startDate, this.settings.endDate)}&Column=${this.item.ColId}&Sources=${encodeURIComponent(JSON.stringify(this.item.Sources))}`;
                    try {

                        const res = await utils.api.get(dataurl);
                        let lookups = [];
                        if (this.item.MappingTableType == 'LookupList' && this.item.lookups)
                            lookups = Object.keys(this.item.lookups);

                        this.listitems = [...new Set([...res.Values, ...lookups, ...this.selected_items])].toSorted((a, b) => this.byTransformedField(a, b));
                    }
                    catch (ex) {
                        this.queryError = ex.message || ex.reasonPhrase;
                        console.error(`Failed to request unique column values (${dataurl}): ${ex.message || ex.reasonPhrase}`);
                    }
                }
                else
                {
                    switch (this.item.SourceType) {
                        case 'userIDColumn':
                            this.listitems = [ '', ...Object.keys(common.userLookup).toSorted((a, b) => this.byTransformedField(a, b)) ];
                            break;

                        case 'customerIDColumn':
                            this.listitems = [ '', ...Object.keys(common.customerLookup).toSorted((a, b) => this.byTransformedField(a, b)) ];
                            break;

                        default:
                             if ((this.item.MappingTableType == 'LookupAPI' || (!this.item.MappingTableType && this.item.DBLookupList)) && !this.showunique) {
                          
                                // Always call this because it is assumed we will refresh this list every time the filter is opened (even though it is loaded at startup)
                                await common.loadLookup(this.item);

                                if (this.item.CompoundFilter)
                                    this.listitems = [...new Set([...this.item.names.map(a => a.name), ...(this.selected_items || [])])].toSorted((a, b) => this.byTransformedField(a, b));
                                else
                                    this.listitems = [...new Set([...Object.keys(this.item.lookups), ...(this.selected_items || []), ''])].toSorted((a, b) => this.byTransformedField(a, b));
                            }
                            else if (this.item.MappingTableType == 'LookupList') {
                                  this.listitems = [...new Set([...Object.keys(this.item.lookups), ...(this.selected_items || []), ''])].toSorted((a, b) => this.byTransformedField(a, b));
                            }
                            break;
                    }
                }

                // For ReadOnly, limited, exclusive mode, the values represents items the user cannot pick, so filter them out
                if (this.initial && this.initial.usage == 2 && this.initial.mode == 'exclusive' && this.initial.values)
                    this.listitems = this.listitems.filter(a => !this.initial.values.includes(a));

                console.log(`loadColumnValues(colId:${this.item.ColId}) returned ${this.listitems.length} item(s) for ${this.item.SourceType}`);

                this.query_in_progress = false;
            },
            
         
            transformValue(item) {
                if (!item)
                    return this.Translate('(Blank)');
                
                switch (this.item.SourceType) {
                    case 'userIDColumn':
                        return common.userLookup[item] || `(${item})`;
                    case 'channelTypeColumn':
                        return item.substring(0, 14) == 'CustomChannel~' ? item.substring(14) : item;
                    case 'customerIDColumn':
                        return common.customerLookup[item] || `(${item})`;
                    case 'phoneNumColumn':
                        if (item.substring(0, 4) == 'USER')
                            return common.userLookup[item.substring(4)] || item;
                        else if (item == '+10000000000')
                            return this.Translate('(Loopback)');
                        else
                            return helps.formatPhoneNumber(item);
                    default:
                        if (this.item.lookups)
                            return this.item.lookups[item] || item;
                        else
                            return item;
                }
            },
            byTransformedField(a, b) {
                switch (this.item.SourceType) {
                    case 'userIDColumn':
                        return common.byField(common.userLookup[a] || a, common.userLookup[b] || b);
                    case 'channelTypeColumn':
                        return common.byField(a.substring(0, 14) == 'CustomChannel~' ? a.substring(14) : a, b.substring(0, 14) == 'CustomChannel~' ? b.substring(14) : b);
                    case 'customerIDColumn':
                        return common.byField(common.customerLookup[a] || a, common.customerLookup[b] || b);
                    default:
                        if (this.item.lookups)
                            return common.byField(this.item.lookups[a] || a, this.item.lookups[b] || b);
                        else
                            return common.byField(a, b);
                }
            },
            relayChange(value) {
                this.selected_items = [ ...value];  
                var updatedThresholdValue = {
                        filterType: "set",
                        value:  [ ...value],
                        mode: this.useExclusive ? 'exclusive' : 'inclusive',
                        displayValues:  [ ...value],
                        type: "set"
                }             
                this.$emit('thresholdValuesChanged', updatedThresholdValue);
            },
            thresholdFormatChanged(message){
                this.$emit('thresholdFormatChanged', message);
            },
            toggleAll(value) {
                console.log(`All Values Changes: ${value}`);            
            },

            triggerValidation() {
                this.valueErrorMessages = [];
                for (const rule of this.valueRules) {
                    const result = rule(this.selected_items);
                    if (typeof result === 'string') {
                        this.valueErrorMessages.push(result);
                        break; // Stop at the first error
                    }
                }
            },            
        }
    }
</script>

<style scoped>
    .verydense {
        max-height: 24px;
        min-height: 24px;
    }
    .mediumdense {
        max-height: 28px;
        min-height: 28px;
    }
    .removepadding {
        padding: 0;
    }
    .search-box {
        border: 1px solid silver;
        border-radius: 3px;
        padding-left: 3px;
        padding-bottom: 1px;
    }

</style>